import styled from '@emotion/styled';
import { Colors } from 'utils';
import PropTypes from 'prop-types';
import device from './device';
const PrimaryButtonV2 = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  background: ${(props) =>
    !props.primary ? Colors.newSecondaryColor : Colors.white};
  ${(props) => props.primary
    ? `
      border: 1px solid #D5D7DA;
    `
    : `
      border: 2px solid transparent;
      border-image: linear-gradient(90deg, #FFFFFF00, #FFFFFF1F);
      border-image-slice: 1;
  `}
  color: ${(props) => (!props.primary ? Colors.white : Colors.black)};
  box-shadow: 0px 1px 2px #0A0D120D;
  box-shadow: 0px -2px 0px #0A0D120D;
  box-shadow: 0px 0px 0px 1px #0A0D122E;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  min-width: ${(props) => (props.minWidth ? props.minWidth : '120px')};
  height: 44px;
  padding: 10px 16px;
  font-size: 16px;
  p {
    color: ${(props) => (!props.primary ? Colors.white : Colors.black)} !important;
    padding: ${(props) => (!props.primary ? `2px 6px 0px 0px !important` : `2px 0px 0px 0px !important`)};
  }
  @media ${device.allMobile} {
    background: ${(props) =>
    !props.primary ? Colors.newSecondaryColor : Colors.white};
    border: 1px solid ${Colors.newSecondaryColor};
    color: ${(props) => (!props.primary ? Colors.white : Colors.black)};
  }
  &:hover {
    background: ${(props) =>
    props.primary ? Colors.hoverBackground : Colors.white};
    color: ${(props) => (props.primary ?? Colors.newSecondaryColor)};
    p {
      color: ${(props) => (props.primary ?? Colors.newSecondaryColor)} !important;
    }
  }
  &:disabled {
    background: ${Colors.steel};
    border: ${Colors.steel};
    color: ${Colors.grey};
    cursor: not-allowed;
  }
`;

export default PrimaryButtonV2;

PrimaryButtonV2.propTypes = {
  primary: PropTypes.bool,
  minWidth: PropTypes.string,
};
